'use client'

import ViverseSkeleton from '@/components/ViverseSkeleton'
import { cn } from '@/lib/utils'

export function ViverseWorldCardSkeleton({
  className,
  cardOnly = false,
}: {
  className?: string
  cardOnly?: boolean
}) {
  return (
    <div
      className={cn(
        'text-card-foreground cursor-wait rounded-3xl border-0 bg-transparent shadow-xs',
        className,
      )}
    >
      <div className="flex w-full flex-col gap-2">
        <ViverseSkeleton className="aspect-430/242 w-full rounded-3xl" />

        {!cardOnly && (
          <div className="flex w-full flex-col gap-1 px-0.5 pt-1">
            <ViverseSkeleton className="h-3.5 w-40 rounded-lg max-lg:w-3/4" />
            <ViverseSkeleton className="h-3 w-24 rounded-lg" />
          </div>
        )}
      </div>
    </div>
  )
}
